// extracted by mini-css-extract-plugin
module.exports = {"milestone-icon":"styles_milestone-icon__3M7Hl"};